// JsFromRoutes CacheKey 15143c913f6a6be74a80e7fc315fcaf7
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  addToCart: /* #__PURE__ */ definePathHelper('post', '/consumer/order_gifts/:id/add_to_cart(/:consumer_order_id)'),
  saveDraft: /* #__PURE__ */ definePathHelper('patch', '/consumer/order_gifts/save_draft'),
  show: /* #__PURE__ */ definePathHelper('get', '/consumer/order_gifts/:id'),
  update: /* #__PURE__ */ definePathHelper('patch', '/consumer/order_gifts/:id'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/consumer/order_gifts/:id'),
}
